import { Color } from "@app/types/Color";

export const MsilColors: Color = {
    success: "#62b866",
    error: "#ff0000",
    secondary: "#e7792b",
};
